/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:1024px){[_nghost-%COMP%]{height:100vh;display:flex;flex-flow:column nowrap;position:relative}}@media (min-width:1024px){[_nghost-%COMP%]{height:100vh;display:flex;flex-flow:column nowrap;position:relative;overflow-x:hidden}}.scrollable-container[_ngcontent-%COMP%]{background-color:#fff;margin:0!important;overflow-x:hidden;-webkit-overflow-scrolling:touch;position:relative}"];
export { styles as styles };
